exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2wehkEKCI8FGA7M-Ck5RjZ {\n  font-weight: 500;\n  font-family: \"sofia-pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  box-sizing: border-box;\n}\n/* Basic call to action */\n._2wehkEKCI8FGA7M-Ck5RjZ {\n  display: block;\n  padding: .5em .8em;\n  font-size: 24px;\n  color: black;\n  border: 3px solid black;\n  text-decoration: none;\n  transition: all 200ms;\n}\n\n  ._2wehkEKCI8FGA7M-Ck5RjZ::after {\n    content: '\\2192';\n    margin-left: 0.5em;\n    display: inline-block;\n    transition: -webkit-transform 200ms;\n    transition: transform 200ms;\n    transition: transform 200ms, -webkit-transform 200ms;\n  }\n\n  ._2wehkEKCI8FGA7M-Ck5RjZ:hover {\n    background: rgba(255, 255, 255, 0.56471)\n  }\n\n    ._2wehkEKCI8FGA7M-Ck5RjZ:hover::after {\n      -webkit-transform: translateX(.2em);\n              transform: translateX(.2em);\n    }", ""]);

// exports
exports.locals = {
	"cta": "_2wehkEKCI8FGA7M-Ck5RjZ"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/Cta/cta.css
 ** module id = 452
 ** module chunks = 0
 **/